import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class VideoSrcsetComponent extends Component {
    static selector () {
        return 'video[data-srcset]'
    }

    constructor (opts) {
        super(opts)

        if (!('matchMedia' in window))
            return

        this.srcset = []

        try {
            this.srcset = JSON.parse(this.props.srcset || '[]')
            this.srcset = Array.isArray(this.srcset)
                ? this.srcset
                : []
        }
        catch (e) {}

        this.render()
        this.listen()
    }

    listen () {
        RootComponent.Scroller.state
            .on('update', this.onScroll.bind(this))

        this.on('resize', this.render.bind(this))

        if (this.props.srcsetPauseOnHover !== 'true')
            return

        this.el
            .addEventListener('mouseenter',
                this.onMouseEnter.bind(this))

        this.el
            .addEventListener('mouseleave',
                this.onMouseLeave.bind(this))

        this.el.parentElement
            .addEventListener('mouseout',
                this.onMouseLeave.bind(this))
    }

    onMouseEnter (e) {
        if (!this.isRevealed()
                || this.el.paused)
            return

        if (this.props.srcsetOnHover !== 'true')
            this.props.srcsetOnHover = true

        try {
            this.el.pause()
        }
        catch (e) {}
    }

    onMouseLeave (e) {
        if (!this.isRevealed()
                || !this.el.paused)
            return

        if (this.props.srcsetOnHover !== 'false')
            this.props.srcsetOnHover = false

        try {
            this.el.play()
        }
        catch (e) {}
    }

    onScroll () {
        if (this.props.srcsetOnHover === 'true')
            return

        const isVisible = this.isVisible()
        const isRevealed = this.isRevealed()

        try {
            if (!isVisible
                    && isRevealed
                    && !this.el.paused)
                this.el.pause()

            if (isVisible
                    && isRevealed
                    && this.el.paused
                    && this.el.autoplay)
                this.el.play()
        }
        catch (e) {}
    }

    isRevealed () {
        return !this.props.scrollRevealAutoplay
            || this.props.scrollRevealAutoplay === 'playing'
    }

    isVisible () {
        const bounds = this.el.getBoundingClientRect()

        const top = bounds.top
        const bottom = top + this.el.clientHeight

        return (top >= 0 && top < window.innerHeight)
            || (bottom >= 0 && bottom < window.innerHeight)
            || (top < 0 && bottom > window.innerHeight)
    }

    render () {
        const src = this.srcset
            .filter(obj => (obj || {}).media
                && (obj || {}).src
                && (window.matchMedia(obj.media) || {}).matches)
            .map(obj => obj.src)[0]

        if (!src || src === this.el.getAttribute('src'))
            return

        this.el.src = src
        this.el.load()
    }
}
